exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-leave__wrapper .button-leave[data-v-464fad2f] {\n  padding: 21px 48px;\n  height: auto;\n  font-size: 18px;\n  line-height: 1.44;\n  font-weight: bold;\n  white-space: normal;\n}", ""]);

// exports
